module.exports = __webpack_public_path__ + "img/box3.1e0db324.png";